import React from "react";
import { Row, Col, Form, Input, Card, Button, Upload, Modal, Alert } from 'antd'
import ProfileBox from './ProfileBox'
import { PlusOutlined, LoadingOutlined } from '@ant-design/icons'
import ImgCrop from 'antd-img-crop'
import api_url from '../../../utils/requestApi'
import ServerApi from '../../../utils/ServerApi'
import appConst from '../../../constents/app.const'

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
})
class AccountUpdate extends React.Component{
    constructor(props){
        super(props)
    }
    formRef = React.createRef()
    state={
        loading: false,
        imageUrl: '',
        authFail: false,
        authFailMsg: 'Input your credential',
        previewOpen: false,
        previewImage: '',
        previewTitle: '',
        fileList: []
    }
    componentDidMount(){}
    onReset = () => {
        this.formRef.current.resetFields()
    }
    onFinish = (e) => {
        e.image = this.state.fileList.length==1?this.state.fileList[0].name:(this.props.userInfo?this.props.userInfo.image:'')
        const serverApi = new ServerApi(appConst.apiUrl, this.props.token)
        serverApi.account_actions(api_url.account_update, 'PATCH', e, returnData => {
            if(returnData.success == 1){
                this.setState({
                    authFail: false,
                    authFailMsg: returnData.message
                }, () => {
                    this.props.onMyAccount()
                })
            }else{
                this.setState({
                    authFail: true,
                    authFailMsg: returnData.message
                })
            }
        })
    }
    render(){
        const handlePreview = async (file) => {
            if (!file.url && !file.preview) {
              file.preview = await getBase64(file.originFileObj);
            }
            this.setState({
                previewImage: file.url || file.preview,
                previewOpen: true,
                previewTitle: file.name || file.url.substring(file.url.lastIndexOf('/') + 1)
            })
        }
        const handleChange = ({fileList: newFileList}) => {
            this.setState({fileList: []}, () => {
                this.setState({fileList: newFileList})
            })
        }
        const uploadButton = (
            <div>
              {this.state.loading ? <LoadingOutlined /> : <PlusOutlined />}
              <div
                style={{
                  marginTop: 8,
                }}
              >
                Upload
              </div>
            </div>
        )
        const handleCancel = () => {
            this.setState({previewOpen: false})
        }
        return(
            <div>
                <Row>
                    <Col xs={0} sm={0} md={0} lg={6} xl={6}></Col>
                    <Col xs={24} sm={24} md={24} lg={12} xl={12}
                        style={{background: 'white'}}
                    >
                        <Card>
                            <Row>
                                <Col xs={0} sm={0} md={0} lg={8} xl={8}
                                    style={{float: 'center'}}
                                >
                                    <ProfileBox userInfo={this.props.userInfo?this.props.userInfo:'Name'}/>
                                </Col>
                                <Col xs={24} sm={24} md={24} lg={16} xl={16}>
                                    <u className="ml-5"><h5>Account Update</h5></u>
                                    {this.state.authFail ? <Alert message={this.state.authFailMsg} type="error" showIcon /> : 
                                    <Alert message={this.state.authFailMsg} type="success" showIcon />}
                                    <Form
                                        ref={this.formRef}
                                        onFinish={this.onFinish}
                                    >
                                        <div>
                                            <label>Fullname</label>
                                            <Form.Item
                                                name="full_name"
                                                rules={[
                                                {
                                                    required: true,
                                                    message: 'Please input full name!',
                                                },
                                                ]}
                                            >
                                                {/* initialValue={this.props.userInfo?.name} */}
                                                <Input placeholder="full name" defaultValue={this.props.userInfo?.name} />
                                            </Form.Item>
                                        </div>
                                        <div>
                                            <label>Phone</label>
                                            <Form.Item
                                                name="mobile_number"
                                                rules={[
                                                {
                                                    required: true,
                                                    message: 'Please input phone number!',
                                                },
                                                ]}
                                            >
                                                <Input placeholder="phone number" defaultValue={this.props.userInfo?.mobile}/>
                                            </Form.Item>
                                        </div>
                                        <div>
                                            <label>Email</label>
                                            <Form.Item
                                                name="email"
                                                rules={[
                                                {
                                                    required: true,
                                                    message: 'Please input email!',
                                                },
                                                ]}
                                            >
                                                <Input placeholder="email" defaultValue={this.props.userInfo?.email}/>
                                            </Form.Item>
                                        </div>
                                        <div>
                                            <label>Image</label>
                                            <Form.Item
                                                name="image"
                                                type="file"
                                            >
                                                <ImgCrop rotationSlider>
                                                    <Upload
                                                        action={appConst.apiUrl+api_url.img_upload_url}
                                                        headers={{
                                                            Authorization: `Bearer `+this.props.token,
                                                        }}
                                                        listType="picture-card"
                                                        fileList={this.state.fileList}
                                                        onPreview={handlePreview}
                                                        onChange={handleChange}
                                                        accept={"image/*"}
                                                    >
                                                        {this.state.fileList.length == 1 ? null : uploadButton}
                                                    </Upload>
                                                    <Modal
                                                        open={this.state.previewOpen}
                                                        title={this.state.previewTitle}
                                                        footer={null}
                                                        onCancel={handleCancel}
                                                    >
                                                        <img
                                                        alt="example"
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                        src={this.state.previewImage}
                                                        />
                                                    </Modal>
                                                </ImgCrop>
                                            </Form.Item>
                                        </div>
                                        <div>
                                            <Form.Item
                                                style={{marginTop: '10px'}}
                                            >
                                                <Button type="primary" htmlType="submit" block>
                                                Submit
                                                </Button>
                                            </Form.Item>
                                        </div>
                                    </Form>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                    <Col xs={0} sm={0} md={0} lg={6} xl={6}></Col>
                </Row>
            </div>
        )
    }
}

export default AccountUpdate;